import http from 'conversations-http/clients/http';
export const getChatflowConnectionStatus = ({
  chatflowId
}) => http.get(`chatflows/v1/chatflows/${chatflowId}/connected-status`);